import { Button, Modal, Form } from 'antd';
import React from 'react';
import styles from './Login.module.scss';
import Api from '../../../api/Api';
import useHomeStore from "../../../store/homeStore";
import useAuthStore from "../../../store/authStore";

export default function AssociateWithCompanyModal() {
  const user = useAuthStore(state => state.user);

  const showAssociateToCompany = useHomeStore(state => state.showAssociateToCompany);
  const setShowAssociateToCompany = useHomeStore(state => state.setShowAssociateToCompany);

  const handleClose = () => {
    setShowAssociateToCompany({status: false, fun: () => null});
  };

  const handleOk = () => {
    showAssociateToCompany.fun()
    setShowAssociateToCompany({status: false, fun: () => null});
  }

  const handleEditCompanyProfile = () => {
    if (Api.DhiSupportUrl && Api.SERVER_DOMAIN) {
      window.open(`${Api.DhiSupportUrl}/company/?redirecttext=MOOD&redirecturl${Api.SERVER_DOMAIN}`, '_blank');
    }
  };

  return (
    <>
      <Modal
        title="Please select your Business Profile"
        open={showAssociateToCompany.status}
        onOk={handleOk}
        onCancel={handleClose}
        footer={[
          <Button key="close" type="default" onClick={handleClose}>Close </Button>,
        ]}
      >
        <p>
          Your email address {user.userName} does not have any business profile selected.
          If you need the invoice to be VAT claimable, please update your user details
          to associate your user details with a company and a corresponding VAT number.
          However, if you want to purchase products and services on your own name without
          a company association, continue as end user.
        </p>
        <p>
          Please select the business profile you want to continue with.
        </p>
        <p>
        <Form.Item
            className={styles.registerFormItemButton}
          >
            <Button
              type="primary"
              className={styles.submitBtn}
              onClick={handleEditCompanyProfile}
            >
              Select Business Profile
            </Button>
          </Form.Item>
        </p>
      </Modal>
    </>
  );
}
